import { DateTime } from "luxon";
import { toStartOfDay } from "@common/utils/localTime.utils";

export const getPointTime = (pointMinutes: number, start?: number) => {
  const startDate = start || toStartOfDay(new Date()).getTime();
  const date = DateTime.fromMillis(startDate);

  return date.plus({ minutes: pointMinutes });
};
